const getDocHeight = () => {
  return Math.max(
    document.body.scrollHeight, document.documentElement.scrollHeight,
    document.body.offsetHeight, document.documentElement.offsetHeight,
    document.body.clientHeight, document.documentElement.clientHeight
  );
};

export const getAmountScrolled = (trackLength) => {
  const scrollTop = window.pageYOffset;
  return Math.floor(scrollTop / trackLength * 100);
};

export const handleResize = () => {
  const winHeight = window.innerHeight;
  const docHeight = getDocHeight();
  return (docHeight - winHeight);
};

